module.exports = __webpack_public_path__ + "img/logo-baib.91667ce7.svg";